const trackFrontEventsUtils = require('od-modules/track_events/track.frontevents.utils');

var defaults = {
    dialogID: '',
    template: '',
    translations: {},
    actions: ['close', 'back', 'retry', 'closeOnClickOutside'],
    customActionReaction: [],
    bindableActions: {
        close: {
            selector: '.dialog_close_btn',
            action: 'tap',
            method: 'close',
        },
        closeOnClickOutside: {
            selector: '.ui_dialog_box',
            action: 'tap',
            method: 'close',
        },
        modalClickInside: {
            selector: '.od-generic-icon-text-dialog',
            action: 'tap',
            method: 'skip',
        },
        back: {
            selector: '.dialog_back_btn',
            action: 'tap',
            method: 'back',
        },
        retry: {
            selector: '.dialog_retry_btn',
            action: 'tap',
            method: 'retry',
        },
        retryAccommodationPB: {
            selector: '.dialog_retry_btn',
            action: 'tap',
            method: 'retryAccommodationPB',
        },
        retryDynpackDeeplink: {
            selector: '.dialog_retry_btn',
            action: 'tap',
            method: 'retryDynpackDeeplink',
        },
        retryReturningVisitor: {
            selector: '.dialog_retry_returning_visitor_btn',
            action: 'tap',
            method: 'retryReturningVisitor',
        },
    },
    dataTracking: {},
};

var DialogsByTemplate = function(options) {
    this.opts = this.getOptions(options);
    this.init();
};

DialogsByTemplate.prototype = {
    init: function() {
        this.setupSelectors();
        this.setupTemplate();
        this.bindEvents();
        this.show();
    },
    getOptions: function(options) {
        return Odigeo._.extend({}, defaults, this.opts, options);
    },
    setupSelectors: function() {
        this.$page = $('#page');
        this.$dialog = $(this.create());
    },
    setupTemplate: function() {
        const template = Odigeo._.template(this.$page.find(this.opts.template).html(), Odigeo.Utils.getTmplSettings());
        this.$template = $(template(this.opts.content));
        this.$dialog.html(this.$template);
    },
    bindEvents: function() {
        Odigeo._.each(this.opts.actions, function(action) {
            const bindableActions = Odigeo._.merge(defaults.bindableActions, this.opts.bindableActions);

            const availableAction = bindableActions[action];

            if ( availableAction && !Odigeo._.isEmpty(availableAction.selector) ) {
                let actionReactionFunction = this[availableAction.method];

                if ( !Odigeo._.isEmpty(this.opts.customActionReaction) && this.opts.customActionReaction[availableAction.method] ) {
                    actionReactionFunction = this.opts.customActionReaction[availableAction.method];
                }

                const $actionElem = (action === 'closeOnClickOutside') ? this.$dialog : this.$dialog.find(availableAction.selector);


                $actionElem.on( Odigeo.Events[availableAction.action], Odigeo._.bind(actionReactionFunction, this));
            }
        }, this);

        if (this.opts.dialogID === 'sessionAboutToExpireAlert' && Odigeo.AB.isNewWarningPopup) {
            this.$dialog.on('dialog:closeOnNavigate', Odigeo._.bind(this.remove, this));
        }

        return this;
    },
    create: function() {
        return `
        <div id ="${this.opts.dialogID}"
            data-id="${this.opts.dialogID}"
            class="od-z-index-9999 ui_dialog_box ui_dialog_content odf-lightbox-bg open opened
            ${this.opts.dialogID === 'sessionAboutToExpireAlert' && Odigeo.AB.isNewWarningPopup ? ' od-new-warning-popup-position' : ''}">
        </div>`;
    },
    show: function() {
        this.$page.append(this.$dialog);
        Odigeo.UIElements.dialogs.push(this.$dialog);
        const shouldTriggerTrackingOnShow = !(['sessionAboutToExpireAlert', 'sessionExpireDialog'].includes(this.opts.dialogID));
        if (shouldTriggerTrackingOnShow) {
            this.track('show');
        }
        trackFrontEventsUtils.trackJQElementDisplayed(this.$dialog);
    },
    removeClass(cssClass) {
        this.$template.removeClass(cssClass);
        Odigeo._.delay(Odigeo._.bind(this.remove, this), 300);
    },
    close: function(e) {
        e.stopPropagation();
        e.preventDefault();

        const closeTypeFixer = e.target.dataset.trackLabel;
        const defaultTrackingCloseLabel = `10min-warning-msg_close_${closeTypeFixer}`;
        let closeTracking = this.opts.dataTracking.close;

        if (closeTypeFixer === 'x' && this.opts.dataTracking.closeIcon) {
            closeTracking = this.opts.dataTracking.closeIcon;
        }
        const closeTrackingLabel = closeTracking.label || defaultTrackingCloseLabel;
        const appendPageLabel = closeTracking.label ? false : true;

        const trackingIds = ['dp-results-inactivity_click:cta-dp', 'dp-results-inactivity_click:cta', 'dp-results-inactivity_click:x'];
        const currentId = e?.target?.dataset?.id;
        if (trackingIds.includes(currentId)) {
            trackFrontEventsUtils.trackClick(currentId);
        }

        this.opts.removeClass ? this.removeClass(this.opts.removeClass) : this.remove(closeTrackingLabel, appendPageLabel);
    },
    remove: function(trackingLabel, appendPageLabel) {
        this.track('close', trackingLabel, appendPageLabel);
        Odigeo.UIElements.dialogs = Odigeo._.without(Odigeo.UIElements.dialogs, this.$dialog);
        Odigeo.UIElements.hideDialog(this.$dialog);
    },
    back: function(e) {
        e.stopPropagation();
        e.preventDefault();
        this.track('back');
        Odigeo.UIElements.hideAllDialogs();
        Odigeo.Utils.goToApplicationHome();
    },
    retry: function(e) {
        e.stopPropagation();
        e.preventDefault();
        this.track('retry');
        Odigeo.UIElements.hideAllDialogs();
        Odigeo.trigger(this.opts.dialogID + ':repeatSearch', Odigeo.History.getPageNameFromFragment());
    },
    retryAccommodationPB: function(e) {
        e.stopPropagation();
        e.preventDefault();
        this.track('retryAccommodationPB');
        Odigeo.UIElements.hideAllDialogs();
        Odigeo.Utils.launchAccommodationPBSearch();
    },
    retryDynpackDeeplink: function(e) {
        e.stopPropagation();
        e.preventDefault();
        this.track('retryDynpackDeeplink');
        Odigeo.UIElements.hideAllDialogs();
        Odigeo.Session.remove('searchParameters');
        Odigeo.Session.remove('lastRouteChange');
        Odigeo.trigger('dpsearch-manager:retryDynpackDeeplink');
    },
    retryReturningVisitor: function(e) {
        e.stopPropagation();
        e.preventDefault();
        this.track('retry');
        Odigeo.UIElements.hideAllDialogs();
        Odigeo.trigger(`${this.opts.dialogID}:repeatSearchReturningVisitor`);
    },
    skip: function() {
        return false;
    },
    track: function(action, trackingLabel, appendPageLabel) {
        const dataTracking = this.opts.dataTracking[action];
        this.tracking({
            ...dataTracking,
            label: trackingLabel || dataTracking && dataTracking.label,
            appendPageLabel: appendPageLabel,
        });
    },
    tracking: function(dataTracking) {
        if (!Odigeo._.isEmpty(dataTracking)) {
            Odigeo.trigger('analytics:tracking', {
                type: 'trackEvent',
                data: {
                    page: !Odigeo._.isEmpty(dataTracking.page) ? dataTracking.page : Odigeo.History.getPageNameFromFragment(),
                    action: dataTracking.action,
                    label: dataTracking.label,
                    analytics: dataTracking.analytics,
                    appendPageLabel: dataTracking.appendPageLabel,
                },
            });
        }
    },
};

module.exports = DialogsByTemplate.prototype.constructor = DialogsByTemplate;
